//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  Field,
  Picker,
  Popup,
} from 'vant'

export default {
  name: 'CSmartPopupPicker',

  components: {
    Popup,
    Picker,
    Field,
  },

  props: {
    value: {
      type: [
        String,
        Number,
      ],
    },

    apiMethod: { type: Function },

    params: {
      type: Object,
      default: () => {},
    },

    nameFormat: {
      type: [
        String,
        Number,
      ],
      default: () => '{name}',
    },

    valueName: {
      type: [
        String,
        Number,
      ],
      default: () => 'key',
    },

    label: { type: String },

    title: { type: String },

    placeholder: { type: String },

    data: { type: Array },
  },

  data () {
    return {
      fieldValue: '',
      selectedIdx: null,
      showPicker: false,
      columns: [],
      allColumns: [],
    }
  },

  computed: {
    defaultIndex: {
      set (value) {
        this.getSelectedFn(value)
      },
      get () {
        return this.getDefaultFn(this.columns)
      },
    },
  },

  watch: {
    data: {
      deep: true,
      handler (v) {
        this.columns = v
      },
    },
  },

  async created () {
    if (this.apiMethod) {
      const { data } = await this.apiMethod(this.params)
      this.allColumns = data?.rows || []
      this.columns = this.allColumns.map((el) => {
        const name = this.filterShowName(el)

        return {
          text: name,
          wid: el[this.valueName],
        }
      })
    }
  },

  methods: {
    filterShowName (val) {
      const value = this.nameFormat.replace(/{[a-zA-Z]+}/g, (key) => val[key.replace(/[{}]/g, '')])

      return (value === 'undefined' && this.all) ? '全部' : value
    },

    getSelectedFn (index) {
      this.$emit('input', this.columns[index] && this.columns[index][this.valueName])
    },

    getDefaultFn (arr) {
      if (arr?.length > 0) {
        const idx = arr.findIndex((el) => {
          const dd = this.value === el[this.valueName]

          return dd
        })

        this.fieldValue = arr[idx]?.text

        return idx
      }
    },

    onConfirm (value, index) {
      this.fieldValue = value.text
      this.defaultIndex = index

      this.$emit('input', this.columns[index] && this.columns[index][this.valueName])
      this.$emit('on-confirm', value, index)
      this.showPicker = false
    },

    onCancel () {
      this.showPicker = false

      this.$emit('on-cancel')
    },

    onChange (item, value, index) {
      this.$emit('on-change', item, value, index)
    },
  },
}
